// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-rich-text-editor {
   padding: var(--padding);
   width: 100%;
   height: 100%;
   min-width: fit-content;
   border: var(--border);
   background-color: var(--alto-gray-20);
   border-radius: var(--border-radius);
}

[data-theme='Dark'] .ecl-rich-text-editor {
   background-color: var(--sub-window-bg);
}

.ecl-rich-text-editor form {
   height: 100%;
   display: flex;
   flex-direction: column;
}

.ecl-rich-text-editor fieldset {
   border: unset;
   max-height: calc(100% - 40px);
   min-height: calc(100% - 40px);
}

.ecl-rich-text-editor .tab-container {
   height: 100%;
   display: flex;
   flex-direction: column;
}

.ecl-rich-text-editor .editor-controls {
   display: flex;
   flex-direction: row;
   border-bottom: 1px solid var(--true-white);
}

markdown-toolbar .themed-svg-container {
   height: 25px; 
   width: 25px;
}

@media (max-width: 769px) and (orientation: portrait),
(max-height: 769px) and (orientation: landscape) {
   .ecl-rich-text-editor .editor-controls {
      flex-direction: column;
   }

   .ecl-rich-text-editor .editor-controls markdown-toolbar {
      justify-content: space-evenly;
      padding: 5px 0;
   }
}

md-header, md-bold, md-italic, md-strikethrough, md-unordered-list, md-ordered-list, md-task-list, md-quote {
   margin-left: 5px;
   margin-right: 5px;
   cursor: pointer;
}

.ecl-rich-text-editor .editor-controls {
   border-bottom: var(--border);
}

.ecl-rich-text-editor .tab-nav {
   display: flex;
}

.ecl-rich-text-editor .tab-nav button {
   border-radius: var(--border-radius) var(--border-radius) 0px 0px;
}

[data-theme='Light'] .ecl-rich-text-editor .tab-nav button {
   background-color: var(--alto-gray);
   color: var(--mine-shaft);
}

.ecl-rich-text-editor .tab-nav .inactive-tab,
[data-theme='Light'] .ecl-rich-text-editor .tab-nav .inactive-tab {
   background-color: unset;
}

.ecl-rich-text-editor markdown-toolbar {
   flex: 1;
   justify-content: end;
   display: flex;
   align-items: center;
}

.ecl-rich-text-editor .rt-icon {
   height: 25px;
   padding: var(--padding-sm);
   cursor: pointer;
}

.ecl-rich-text-editor .preview-container.tab-view {
   padding: var(--padding);
}

.ecl-rich-text-editor .tab-view {
   padding: var(--padding);
   flex: 1;
   display: flex;
   flex-direction: column;
   min-height: 50px;
}

.ecl-rich-text-editor textarea {
   resize: none;
   border: unset;
   width:100%;
}

.ecl-rich-text-editor .button-div {
   display: flex;
   justify-content: end;
}

.ecl-rich-text-editor .rich-text-submit-button {
   width: fit-content
}

#ECLModal .rt-editor-user-picker-container {
   height: 350px;
}

/* Rich Text Changes */
.contains-task-list {
   list-style: none;
}

.contains-task-list input {
   height: 15px;
}

/* List styling for rich text and comments */
.ecl-comments ul li ul li {
   list-style-type: circle;
}

.ecl-comments ul li ul li {
   list-style-type: circle;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLRichText/ECLRichTextEditor/ECLRichTextEditor.css"],"names":[],"mappings":"AAAA;GACG,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,sBAAsB;GACtB,qBAAqB;GACrB,qCAAqC;GACrC,mCAAmC;AACtC;;AAEA;GACG,sCAAsC;AACzC;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,6BAA6B;GAC7B,6BAA6B;AAChC;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,0CAA0C;AAC7C;;AAEA;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;;GAEG;MACG,sBAAsB;GACzB;;GAEA;MACG,6BAA6B;MAC7B,cAAc;GACjB;AACH;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,4BAA4B;AAC/B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,gEAAgE;AACnE;;AAEA;GACG,kCAAkC;GAClC,wBAAwB;AAC3B;;AAEA;;GAEG,uBAAuB;AAC1B;;AAEA;GACG,OAAO;GACP,oBAAoB;GACpB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,0BAA0B;GAC1B,eAAe;AAClB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;GACvB,OAAO;GACP,aAAa;GACb,sBAAsB;GACtB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,UAAU;AACb;;AAEA;GACG,aAAa;GACb,oBAAoB;AACvB;;AAEA;GACG;AACH;;AAEA;GACG,aAAa;AAChB;;AAEA,sBAAsB;AACtB;GACG,gBAAgB;AACnB;;AAEA;GACG,YAAY;AACf;;AAEA,4CAA4C;AAC5C;GACG,uBAAuB;AAC1B;;AAEA;GACG,uBAAuB;AAC1B","sourcesContent":[".ecl-rich-text-editor {\r\n   padding: var(--padding);\r\n   width: 100%;\r\n   height: 100%;\r\n   min-width: fit-content;\r\n   border: var(--border);\r\n   background-color: var(--alto-gray-20);\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n[data-theme='Dark'] .ecl-rich-text-editor {\r\n   background-color: var(--sub-window-bg);\r\n}\r\n\r\n.ecl-rich-text-editor form {\r\n   height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.ecl-rich-text-editor fieldset {\r\n   border: unset;\r\n   max-height: calc(100% - 40px);\r\n   min-height: calc(100% - 40px);\r\n}\r\n\r\n.ecl-rich-text-editor .tab-container {\r\n   height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n}\r\n\r\n.ecl-rich-text-editor .editor-controls {\r\n   display: flex;\r\n   flex-direction: row;\r\n   border-bottom: 1px solid var(--true-white);\r\n}\r\n\r\nmarkdown-toolbar .themed-svg-container {\r\n   height: 25px; \r\n   width: 25px;\r\n}\r\n\r\n@media (max-width: 769px) and (orientation: portrait),\r\n(max-height: 769px) and (orientation: landscape) {\r\n   .ecl-rich-text-editor .editor-controls {\r\n      flex-direction: column;\r\n   }\r\n\r\n   .ecl-rich-text-editor .editor-controls markdown-toolbar {\r\n      justify-content: space-evenly;\r\n      padding: 5px 0;\r\n   }\r\n}\r\n\r\nmd-header, md-bold, md-italic, md-strikethrough, md-unordered-list, md-ordered-list, md-task-list, md-quote {\r\n   margin-left: 5px;\r\n   margin-right: 5px;\r\n   cursor: pointer;\r\n}\r\n\r\n.ecl-rich-text-editor .editor-controls {\r\n   border-bottom: var(--border);\r\n}\r\n\r\n.ecl-rich-text-editor .tab-nav {\r\n   display: flex;\r\n}\r\n\r\n.ecl-rich-text-editor .tab-nav button {\r\n   border-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n}\r\n\r\n[data-theme='Light'] .ecl-rich-text-editor .tab-nav button {\r\n   background-color: var(--alto-gray);\r\n   color: var(--mine-shaft);\r\n}\r\n\r\n.ecl-rich-text-editor .tab-nav .inactive-tab,\r\n[data-theme='Light'] .ecl-rich-text-editor .tab-nav .inactive-tab {\r\n   background-color: unset;\r\n}\r\n\r\n.ecl-rich-text-editor markdown-toolbar {\r\n   flex: 1;\r\n   justify-content: end;\r\n   display: flex;\r\n   align-items: center;\r\n}\r\n\r\n.ecl-rich-text-editor .rt-icon {\r\n   height: 25px;\r\n   padding: var(--padding-sm);\r\n   cursor: pointer;\r\n}\r\n\r\n.ecl-rich-text-editor .preview-container.tab-view {\r\n   padding: var(--padding);\r\n}\r\n\r\n.ecl-rich-text-editor .tab-view {\r\n   padding: var(--padding);\r\n   flex: 1;\r\n   display: flex;\r\n   flex-direction: column;\r\n   min-height: 50px;\r\n}\r\n\r\n.ecl-rich-text-editor textarea {\r\n   resize: none;\r\n   border: unset;\r\n   width:100%;\r\n}\r\n\r\n.ecl-rich-text-editor .button-div {\r\n   display: flex;\r\n   justify-content: end;\r\n}\r\n\r\n.ecl-rich-text-editor .rich-text-submit-button {\r\n   width: fit-content\r\n}\r\n\r\n#ECLModal .rt-editor-user-picker-container {\r\n   height: 350px;\r\n}\r\n\r\n/* Rich Text Changes */\r\n.contains-task-list {\r\n   list-style: none;\r\n}\r\n\r\n.contains-task-list input {\r\n   height: 15px;\r\n}\r\n\r\n/* List styling for rich text and comments */\r\n.ecl-comments ul li ul li {\r\n   list-style-type: circle;\r\n}\r\n\r\n.ecl-comments ul li ul li {\r\n   list-style-type: circle;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
